var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinanceiro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hand-holding-up-a-financial-graph",
    transform: "translate(-8.853 77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3044",
    "data-name": "Grupo 3044",
    transform: "translate(8.853 -77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2217",
    "data-name": "Caminho 2217",
    d: "M28.193,207.633c-1.478.095-3.422,1.652-5.3,2.546-2.3,1.095-5.875.213-5.875.213.551-.271,2.794-.834,3.246-1.044,2.4-1.112,2.2-3.431,1.053-3.412-1.51.025-2.4.417-5.411.85-2.284.327-4.986.208-6.282.729-1.829.736-4.775,5.687-4.775,5.687l4.556,4.651s2.82-2.926,4.192-2.926c3.126,0,3.253-.044,6.156-.209a6.088,6.088,0,0,0,2.2-.375c3.763-1.341,7.8-4.91,7.878-5.339C30.006,208.01,28.974,207.581,28.193,207.633Z",
    transform: "translate(-4.853 -192.854)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2218",
    "data-name": "Caminho 2218",
    d: "M221.39,102.866a.215.215,0,0,0-.215.214v5.466a.214.214,0,0,0,.215.214h1.959a.215.215,0,0,0,.215-.214V103.08a.215.215,0,0,0-.215-.214Z",
    transform: "translate(-206.166 -96.039)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2219",
    "data-name": "Caminho 2219",
    d: "M273.191,66.34v8.165a.214.214,0,0,0,.215.214h1.959a.214.214,0,0,0,.215-.214V66.34a.215.215,0,0,0-.215-.215h-1.959A.215.215,0,0,0,273.191,66.34Z",
    transform: "translate(-254.573 -61.806)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2220",
    "data-name": "Caminho 2220",
    d: "M169.369,76.848a.215.215,0,0,0-.215.216V84.44a.214.214,0,0,0,.215.214h1.959a.214.214,0,0,0,.215-.214V77.064a.215.215,0,0,0-.215-.216Z",
    transform: "translate(-157.754 -71.802)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2221",
    "data-name": "Caminho 2221",
    d: "M117.354,108.072a.214.214,0,0,0-.215.214v5.084a.214.214,0,0,0,.215.214h1.959a.214.214,0,0,0,.215-.214v-5.084a.214.214,0,0,0-.215-.214Z",
    transform: "translate(-109.348 -100.886)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2222",
    "data-name": "Caminho 2222",
    d: "M117.126,7.219a.288.288,0,0,0,.219.1.281.281,0,0,0,.185-.069l3.915-3.31,3.435,2.627a.285.285,0,0,0,.391-.04l3.172-3.661.444.385a.287.287,0,0,0,.47-.162l.529-2.749a.289.289,0,0,0-.093-.272.291.291,0,0,0-.282-.055l-2.646.916a.286.286,0,0,0-.094.487l.444.386-2.348,2.71L121.577,2a.286.286,0,0,0-.359.01l-4.737,4a.287.287,0,0,0-.1.2.291.291,0,0,0,.067.21Z",
    transform: "translate(-109.038 0)",
    fill: "#64c2c8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceiro);
export default __webpack_public_path__ + "static/media/financeiro.b45e159b128dcb20c5e835e991b26149.svg";
export { ForwardRef as ReactComponent };